module.exports = __webpack_public_path__ + "media/images/icons/large-arrow-up-fae2e5c85c0d8498b43ca57c6ccd733f.svg";